import { useEffect, useState, type ReactNode } from "react";
import { AuthProvider } from "../contexts/auth-context";
import { useAuthStore } from "../stores/auth-store";
import { wireReaderAuthProvider } from "../lib/platform-auth";

let wired = false;

export function AuthGate({ children }: { children: ReactNode }) {
  const [hydrated, setHydrated] = useState(() =>
    useAuthStore.persist.hasHydrated(),
  );

  useEffect(() => {
    if (!wired) {
      wireReaderAuthProvider();
      wired = true;
    }
    const unsub = useAuthStore.persist.onFinishHydration(() => setHydrated(true));
    if (useAuthStore.persist.hasHydrated()) setHydrated(true);
    return unsub;
  }, []);

  if (!hydrated) {
    return (
      <div className="reader-login" dir="rtl">
        <p className="settings-hint">در حال بارگذاری نشست…</p>
      </div>
    );
  }

  return <AuthProvider>{children}</AuthProvider>;
}
